export const locale = {
  country: 'uk',
  currency: 'gbp',
  language: 'en-gb',
}
const site = window.location.host

const browseCallbackPageLoad = {
  page: {
    locale,
    pageInfo: {
      breadCrumb: [
        { value: 'sso:browse', clickable: 1 },
        { value: 'callback', clickable: 0 },
      ],
      pageName: 'jl:sso:browse:callback',
      pageType: 'account',
      site,
    },
  },
}

export type AnalyticsEvent = 'browseCallbackPageLoad'

export type AnalyticsMap = {
  [key in AnalyticsEvent]: Record<string, unknown>
}

export const analyticsMap: AnalyticsMap = {
  browseCallbackPageLoad,
}
